import React from 'react';

const BookLoader = () => {
  return <span className="book-loader"></span>;
};

export default BookLoader;
